var CustomImage = function(element, options){
    this.settings = $.extend({}, this.defaults, options);
    this.element = element;
    this.$element = $(element);
    this.init();
};
 
CustomImage.prototype = {
    
    // shorthand for using prototype
    constructor : CustomImage,
    
    // default options
    defaults : {
        action : '/',
        params : {},
        allowedExtensions : [],
        multiple : false,
        sizeLimit : 10450000, // tested error responses to get this to 10.0 MB
        minSizeLimit : 0,
        maxWidth : 8000,
        maxHeight : 8000,
        debug : false,
        enableCrop : true,
        cropWidth : 200,
        cropHeight : 200,
        showDefaultControls : 'never',
        onSubmit : function(id, fileName){},
        onValidationError : function(){},
        onProgress: function(id, fileName, loaded, total){},
        onComplete: function(id, fileName, responseJSON){},
        onCancel: function(id, fileName){},
        onError: function(id, fileName, xhr){},
        onCrop : function(e, data){},
        onCropComplete : function(){},
        onCropCancel : function(){},
        onUploadCancel : function(){}
    },

    fileID : null,

    crop : '',

    position : '',
    
    init : function(){
        var _this = this;

        var $container = _this.$element.closest('.ui-custom-image-container'),
            $default = $container.find('.ui-custom-image-placeholder'),
            $image = $container.find('.ui-custom-image');

        var uploader = new qq.FileUploaderBasic({
            button : _this.$element[0],
            action: _this.settings.action,
            multiple : _this.settings.multiple,
            sizeLimit : _this.settings.sizeLimit,
            onSubmit : function(id, filename){
                _this.fileID = id; 

                // check for allowed extensions
                if ( _this.settings.allowedExtensions.length > 0 && ! ($.inArray(filename.toLowerCase().split('.').pop(), _this.settings.allowedExtensions) > -1) ){
                    var _extensions = _this.settings.allowedExtensions.join(', ');

                    _this.settings.onValidationError.call(this, id, filename, 'You have submitted an invalid extension. The following extensions are allowed: ' + _extensions + '.', $container);
                    
                    return false;
                }

                _this.settings.onSubmit.call(this, $image, $container, id, filename);

                $container.addClass('ui-custom-image-uploading');

                $image.add($default).fadeTo(500, 0);

                $container.find('.upload-image, .ui-custom-image-default-placeholder').addClass('hide-content');
            },
            onProgress: function(id, filename, loaded, total){
                _this.settings.onProgress.call(this, id, filename, loaded, total);
            },
            onComplete: function(id, filename, response){
                if ( response.success ){
                    var path = response.url;

                    $container.removeAttr('style');

                    _this.settings.onComplete.call(this, $image, $container, id, filename, path, response);

                    $image.attr('src', response.url);
                    
                    $image.fadeTo(500, 1).css('display', 'block');

                    $default.addClass('hide-content').removeAttr('style');

                    $container.removeClass('ui-custom-image-uploading');

                    if ( _this.settings.enableCrop && $.fn.cropbox ) {

                        $container.find('.ui-custom-image-toolbar').removeClass('hide-content');

                        $image.cropbox({
                            width : _this.settings.cropWidth,
                            height : _this.settings.cropHeight,
                            showControls : _this.settings.showDefaultControls
                        }).on('cropbox', function(e, data){
                            _this.crop = data;

                            $container.find('.custom-image-name').val(filename);
                            $container.find('.custom-image-path').val(path);
                            $container.find('.custom-image-crop-x').val(data.cropX);
                            $container.find('.custom-image-crop-y').val(data.cropY);
                            $container.find('.custom-image-crop-w').val(data.cropW);
                            $container.find('.custom-image-crop-h').val(data.cropH);

                            var cropStyles = $image.attr('style');

                            _this.position = cropStyles;

                            _this.settings.onCrop.call(this, e, data);
                        });

                        var imageCrop = $image.data('cropbox');
                        
                        imageCrop.onInit = function(){
                            this.$frame.css('display', 'block');

                            $container.find('.crop-zoom-in').on('click pointerdown', $.proxy(this.zoomIn, this));
                            $container.find('.crop-zoom-out').on('click pointerdown', $.proxy(this.zoomOut, this));
                        };

                        imageCrop.onInit();

                        // makes sure no listeners exist before binding to prevent duplicate behavior
                        $container.find( '.save-image' ).off( 'click pointerdown' ).on( 'click pointerdown' , function( e ){
                            // validation for max width and height
                            $( '<img/>' ).attr( 'src', path ).on('load', function() {
                                if ( _this.settings.maxWidth != 0 && _this.settings.maxHeight != 0 && this.width > _this.settings.maxWidth || this.height > _this.settings.maxHeight ) {
                                    $container.find( '.ui-custom-image-cancel-crop' ).trigger( 'click' );

                                    _this.settings.onValidationError.call(this, id, filename, 'Error saving image. Please upload an image that is no larger than ' + _this.settings.maxWidth + ' x ' + _this.settings.maxHeight + ' pixels.', $container);

                                    return false;
                                }
                            });
                            
                            imageCrop.remove();
                            $(this).closest('.ui-custom-image-toolbar').addClass('hide-content');
                            $container.addClass('has-cropped-image');
                            $container.outerHeight(_this.settings.cropHeight);
                            $container.find('.upload-image').removeClass('hide-content');
                            $image.attr('style', _this.position).css({ 
                                'opacity'   : '1',
                                'display'   : 'block',
                                'position'  : 'absolute',
                                'max-width' : 'none'
                            });
                            _this.settings.onCropComplete.call(this, $image, $container);

                            e.preventDefault();
                        });

                        $container.find( '.ui-custom-image-cancel-crop' ).off( 'click pointerdown' ).on( 'click pointerdown', function( e ){
                            var defaultImage = $container.attr('data-image');

                            $default.removeClass('hide-content').fadeTo(500, 1, function(){
                                $(this).removeAttr('style');
                            });
                            $image.hide();

                            // hide the crop UI
                            imageCrop.remove();
                            $(this).closest('.ui-custom-image-toolbar').addClass('hide-content');

                            _this.settings.onCropCancel.call(this, $image, $container, defaultImage);
                            
                            e.preventDefault();
                        });
                    }
                }
            },
            onCancel: function(id, filename){
                $container.removeClass('ui-custom-image-uploading');
                _this.settings.onCancel.call(this, $image, $container, id, filename);
            },
            onError: _this.settings.onError
        });

        $container.find('.ui-custom-image-cancel').on('click', function(e){
            var defaultImage = $container.attr('data-image');

            $default.fadeTo(500, 1, function(){
                $(this).removeAttr('style');
            });
            $image.hide();

            if ( $container.hasClass('ui-custom-image-uploading') ){
                uploader._handler._cancel(_this.fileID);              
            }

            _this.settings.onUploadCancel.call(this, $image, $container, defaultImage);  

            e.preventDefault();
        });
    }   
    
};

$.fn.customImage = function ( options ) {
    this.each(function() {
        if ( !$.data( this, "qg_customimage" ) ) {
            $.data( this, "qg_customimage", new CustomImage( this, options ) );
        }
    });

    // chain jQuery functions
    return this;
};